/**
 * CSENDES BEJELENTKEZÉS-MEGÚJÍTÁS a weben — KÖZÖS mag a három kérés-út számára.
 * [Web 7 / T1, 2026-10-05]
 *
 * MI VOLT A BAJ (web UX 2. kör 1.1 / TOP 1): a web a 24 órás JWT-t (`backend/PinyoApi/appsettings.json`
 * `JwtSettings:ExpirationHours`) SOHA nem újította meg — a régi `authService.refreshToken()` (a régi
 * `services/authService.ts:172`) hívó nélkül állt. Aki tegnap 17:00-kor lépett be, ma 17:15-kor a
 * lejárt-ablakkal találkozott, akár a jelenléti ív MENTÉSEKOR. A szerver `/auth/refresh` végpontja kész
 * (`backend/PinyoApi/Controllers/AuthController.cs` `RefreshToken`, `Services/JwtRefreshValidation`): a
 * jól aláírt, de LEJÁRT tokent is megújítja 30 napig (`JwtSettings:RefreshGraceDays`). A mobil 12 órával
 * előre megújít (`mobile/services/apiClient.ts` `REFRESH_AHEAD_SECONDS`).
 *
 * A HÁROM ÚT (a `utils/session.ts` fejléce szerint) ugyanezt a magot használja:
 *   1) az `api` (`axios.create`) példány request- és response-interceptora (`services/authService.ts`),
 *   2) a GLOBÁLIS `axios` request- és response-interceptora (ugyanott — a példányét NEM örökli),
 *   3) a nyers `fetch` — ma minden hitelesített hívás az `authFetch` (`utils/authFetch.ts`) burkolón megy.
 *
 * MŰKÖDÉS:
 *   - KÉRÉS INDULÁSAKOR (`resolveRequestToken`): ha a küldendő token 1 órán belül lejár VAGY már lejárt,
 *     előbb egy csendes `POST /auth/refresh` megy (a régi Bearerrel), a token + user a `localStorage`-ba
 *     kerül, és az eredeti kérés MÁR AZ ÚJ tokennel indul.
 *   - 401-RE (`afterUnauthorized`): ha a szerver mégis elutasította (pl. eltérő óra a gépen, vagy a
 *     token a kliens szerint még bőven él), EGYSZER megpróbáljuk a megújítást, és a kérést megismételjük.
 *     Ha a megújítás VÉGLEGESEN bukik, a hívó a MEGLÉVŐ `reportUnauthorized` → `notifySessionExpired()` utat
 *     járja (újra-belépő ablak / kijelentkeztetés) — a 2. csomag viselkedése változatlan. (ÁTMENETI
 *     bukásnál lásd az F-A pontot lent.) CSAK 401-re: a 403 / 5xx nem hitelesítési hiba (F-C).
 *   - Kérésenként LEGFELJEBB EGY megújítási kísérlet (a kérés-indításkori VAGY a 401 utáni): így a
 *     megújítás bukása után nincs végtelen kör, és a lejárat ugyanúgy jelződik, mint eddig.
 *     [Web 7 / T1 javító kör 2, 2026-10-06] F-B: ez az invariáns az ÁTMENETI bukásra is áll (az 1.
 *     javító kör F2-je ott még két kísérletet engedett); őre a `RefreshAttempt` jelző, amit a kérés
 *     indulásakor kapott eredményből a hívó (`authFetch`, `authService` interceptorok) a 401-ágnak
 *     (`afterUnauthorized`) továbbad. Tesztek: `tokenRefresh.test.ts` „F-B".
 *   - [Web 7 / T1 javító kör 2, 2026-10-06] F-A — ÁTMENETI megújítási hiba a 401-ágon NEM lejárat. Mérve
 *     (2. validátor-kör, `scratchpad/t1-val2/fe/e2e/probe.spec.ts` S1): 2 órája lejárt token + a
 *     `/auth/refresh` mindig 503 → a betöltés bent tartott (F2), de a Dashboard kérései a lejárt tokennel
 *     401-et kaptak, a 401-ág megújítása is 503-mal bukott, és a régi kód ezt lejáratnak vette →
 *     1,5 mp alatt a `/belepes` jött „Lejárt a bejelentkezésed" üzenettel, a tároló ürült (a 30 napig
 *     megújítható token elveszett). DÖNTÉS (koordinátor): ha a kérés EGY megújítása átmeneti hibával
 *     (5xx, hálózat, 408, 429, időtúllépés) bukott, a 401-ág `unavailable`-t ad: NINCS lejárat-jelzés,
 *     a tároló marad, a kérés a `REFRESH_UNAVAILABLE_MESSAGE` szöveggel bukik (axios-úton a hibaobjektum
 *     503-as `response.data.message`-e, `fetch`-úton egy szintetikus 503-as JSON-válasz — mindkettőt a
 *     meglévő `apiErrorMessage` / `responseErrorMessage` változatlanul kiolvassa). A következő kérés
 *     (lejárt tokennél hűtés nélkül) újra próbál. A VÉGLEGES bukás (401/403/404 a megújításon) továbbra
 *     is a meglévő lejárat-jelzés.
 *   - Maga a `/auth/refresh`, `/auth/login`, `/auth/logout` (és a többi auth-folyamat végpont,
 *     `isAuthFlowUrl`) SOHA nem indít megújítást — különben önmagát hívó kör lenne.
 *
 * DÖNTÉS — KÜSZÖB: 1 óra (nem a mobil 12 órája). Indok: a web minden kérés ELŐTT ellenőriz, és a szerver
 * a LEJÁRT tokent is megújítja 30 napig, tehát a küszöb csak azt dönti el, mennyivel korábban cseréljük a
 * tokent — a felhasználó szempontjából mindkettő „sosem dob ki". Az 1 óra (a) kevesebb tokencserét jelent
 * (egy 24 órás tokenből 23 óra használódik ki, nem 12), (b) elég tartalék egy hosszú, nyitva hagyott
 * űrlaphoz is, hiszen a következő kérés úgyis megújít, (c) a gép órájának kis eltérését elnyeli; nagy
 * eltérésnél a 401 utáni egyszeri megújítás a tartalék. A mobilon azért kell a 12 óra, mert ott a
 * megújítás bukása kiléptet; itt a 30 napos türelmi idő miatt a lejárt token is megújul.
 *
 * DÖNTÉS — SZERVER: NINCS szerver-változás. A 30 napos türelmi idő a webnek bőven elég: aki 30 napon
 * belül bármikor visszatér, csendben bent marad; aki 30 napnál tovább nem nyitotta meg, az ugyanúgy a
 * belépő oldalt kapja „Lejárt a bejelentkezésed" üzenettel, mint eddig.
 *
 * VERSENY-VÉDELEM: párhuzamos kéréseknél (a Dashboard betöltéskor sok kérést indít) EGY megújítás fut —
 * a futó Promise-t a kiinduló token szerint osztjuk meg (`inFlight`); a többi kérés megvárja, és az új
 * tokennel megy.
 *
 * KIJELENTKEZÉS-VERSENY (a mobil M1 lelete: kijelentkezés közben beérő megújítás visszaírta a tokent →
 * a kilépett felhasználó újra bent volt): a beérő választ CSAK akkor írjuk be, ha
 *   (a) a hitelesítési GENERÁCIÓ nem változott (`bumpAuthGeneration` — a kijelentkezés, a belépés, az
 *       újra-belépés és a munkamenet vége lépteti; ez az A→B→A esetet is fogja: kilépés + ugyanazzal a
 *       tokennel visszakerülés),
 *   (b) a tárolóban MÉG a kiinduló token van (közben nem lépett be más, és nem ürült a tároló),
 *   (c) NEM áll a lejárt-zár (`isSessionExpiredLocked`). Indok: a zár akkor áll, ha a szerver a tokent
 *       már elutasította (és a megújítás is bukott), vagy egy másik fülön kijelentkeztek — ilyenkor a
 *       felület az újra-belépő ablakot mutatja / kijelentkeztet. Egy a modál MÖGÖTT csendben beírt token
 *       összeakadna vele: az ablak nyitva maradna egy közben „élő" munkamenet fölött, a mentetlen ágon
 *       törölt token pedig visszakerülne. Ezért zár alatt sem új megújítás nem indul, sem a beérő nem ír;
 *       a zárat csak a sikeres (újra)belépés oldja (`resetSessionExpired`).
 * Ha a válasz így eldobásra kerül, a várakozó kérés a tárolóban talált tokennel megy tovább, de CSAK ha
 * ugyanannak a felhasználónak a tokenje (pl. egy másik fül épp megújított) — különben a kérés megszakad
 * (`AuthSessionChangedError`), és nem mehet ki egy másik felhasználó nevében.
 *
 * [Web 7 / T1 javító kör 1, 2026-10-06] M5 — TUDATOS: a nyers `fetch`-úton (`authFetch`) az `AuthSessionChangedError` NEM
 * `Response`, hanem dobott hiba, így a hívó-helyek `catch`-ága (amely ma „hálózati hiba"-szöveget mutat)
 * kaphatja meg. Ez CSAK kijelentkezés / felhasználóváltás KÖZBEN fordulhat elő, amikor a felület épp
 * lebomlik (a belépő oldalra vált) vagy kijelentkeztet — a hibaszöveg legfeljebb egy pillanatra villan,
 * és a kérés helyesen NEM megy ki. Külön kezelés a ~4 hívó-helyen több kockázatot hozna, mint hasznot.
 *
 * TÖBB FÜL: a `localStorage` közös. Ha az egyik fül megújít, a többi fül a `storage` eseményben ugyanazt
 * a felhasználót látja új tokennel (`AuthContext` `storage`-kezelő: nincs teendő), és a következő kérése
 * már a tárolóból olvasott friss tokent küldi. Ha két fül egyszerre újít, mindkettő érvényes tokent kap
 * (a szerver nem vonja vissza a régit); a később beérő a (b) feltételen elakad, és a tárolóban lévő
 * (azonos felhasználójú) tokennel folytatja. Nem kötelező funkció, de nem törik.
 * [Web 7 / T1 javító kör 3, 2026-10-06] B1: ez a betöltéskori úton (`refreshStoredSession`) KORÁBBAN NEM
 * állt — az eldobott válasz `none` lett, és az `AuthContext` init törölte a másik fül érvényes tokenjét
 * (mind kilépett). Ma ott is a tárolt, azonos felhasználójú, érvényes token jön, és az init csak a
 * VÁLTOZATLAN tárolót üríti (`AuthContext.tsx` `clearStoredAuthIfUnchanged`).
 *
 * [Web 7 / T1 javító kör 1, 2026-10-06] M6 — TUDATOS: ha egy kérés MÉG a másik fül által már lecserélt (régi) tokennel ment ki,
 * és arra 401 jön, a 401-ág (`afterUnauthorized`) se nem ismétel (a `replacementFor` csak a SAJÁT
 * cserénket ismeri), se nem jelez (a `reportUnauthorized` tároló-összevetése az elavult tokenre nem
 * jelez) — a kérés hibával végződik. Ritka: a régi token a szerver szerint még a lejáratáig érvényes
 * (a szerver nem vonja vissza), tehát ehhez a régi tokennek a két fül cseréje közötti pillanatban kell
 * lejárnia ÉS a szervernek elutasítania. A következő kérés már a tárolt friss tokennel megy.
 */
import axios from 'axios';
import { API_BASE_URL } from './config';
import { isAuthFlowUrl, isSessionExpiredLocked } from './session';
import type { User } from '../types/auth';

/** Ennyivel a lejárat ELŐTT már megújítunk (lásd a fejléc DÖNTÉS — KÜSZÖB pontját). */
export const REFRESH_AHEAD_MS = 60 * 60 * 1000;

/**
 * Ha egy épp megújított token a gép órája szerint MÁR IS „közel lejártnak" látszik (a gép órája
 * nagyon siet), ennyi ideig nem újítjuk meg előre újra — különben minden kérés előtt megújítás menne.
 */
const FRESH_TOKEN_GRACE_MS = 10 * 60 * 1000;

/**
 * [Web 7 / T1 javító kör 1, 2026-10-06] F2-M1 — HŰTÉSI IDŐ átmeneti hiba után. Ha a megújítás ÁTMENETI hibával bukott (5xx,
 * hálózati hiba, 408, 429, időtúllépés), a kérés-indításkori ELŐRE-megújítás (még ÉRVÉNYES tokennél)
 * ennyi ideig nem indul újra. Indok: a Dashboard betöltéskor és utána is sok kérést indít; egy leállt
 * szervernél (vagy 429-nél) minden kérés előtt egy újabb `/auth/refresh` menne — „kérés-vihar", ami a
 * 429-et csak rontja. A még érvényes token a hűtés alatt is működik, tehát semmit nem veszítünk.
 * LEJÁRT tokennél és a 401-ágon a próba a hűtés alatt is mehet (ott nincs más út a bent maradáshoz);
 * a párhuzamos hívók továbbra is EGY Promise-on osztoznak (`inFlight`).
 */
export const TRANSIENT_COOLDOWN_MS = 30 * 1000;

/**
 * [Web 7 / T1 javító kör 1, 2026-10-06] F2-M2 — a `/auth/refresh` időkorlátja. Korábban nem volt: egy beakadt megújítás az
 * ÖSSZES rá váró kérést (`inFlight`) a végtelenségig tartotta. A lejárat ÁTMENETI hibának számít.
 */
export const REFRESH_TIMEOUT_MS = 15 * 1000;

/**
 * [Web 7 / T1 javító kör 2, 2026-10-06] F-A — ezt látja a felhasználó, ha a kérés 401-et kapott, és a
 * megújítás ÁTMENETI hibával bukott. A bejelentkezés (a tárolt token) MEGMARAD.
 */
export const REFRESH_UNAVAILABLE_MESSAGE =
  'A szerver átmenetileg nem érhető el, a bejelentkezésed megmaradt. Próbáld újra kicsit később.';

/**
 * [Web 7 / T1 javító kör 2, 2026-10-06] F-A / F-B — a kérés-INDÍTÁSKORI megújítási kísérlet sorsa:
 *   - `none`: nem volt kísérlet (a token még bőven él, hűtés, zár, auth-folyamat URL, nem JWT alakú);
 *   - `done`: volt kísérlet, és NEM átmeneti hibával végződött (siker, végleges elutasítás, eldobás);
 *   - `transient`: volt kísérlet, és ÁTMENETI hibával bukott (5xx, hálózat, 408, 429, időtúllépés).
 * A 401-ág (`afterUnauthorized`) ebből tudja, hogy a kérés EGY megújítása elfogyott-e már, és hogy a 401
 * átmeneti elérhetetlenség-e (nem lejárat).
 */
export type RefreshAttempt = 'none' | 'done' | 'transient';

/** [Web 7 / T1 javító kör 2, 2026-10-06] A 401 utáni teendő (`afterUnauthorized`). */
export type UnauthorizedOutcome =
  /** a kérés EGYSZER megismételhető ezzel a tokennel */
  | { kind: 'retry'; token: string }
  /** F-A: a megújítás átmeneti hibával bukott — NEM lejárat; a kérés `REFRESH_UNAVAILABLE_MESSAGE`-dzsel bukik */
  | { kind: 'unavailable' }
  /** nincs ismétlés: a hívó a meglévő lejárat-jelzést (`reportUnauthorized`) végzi — változatlanul */
  | { kind: 'report' };

/** A megújítás eredménye. */
export type RefreshOutcome =
  /** `expiration`: a szerver által küldött lejárat (`AuthResponseDto.Expiration`), ha volt — [Web 7 / T1 javító kör 1, 2026-10-06] M4 */
  | { kind: 'ok'; token: string; user: User; expiration?: string }
  /**
   * a szerver elutasította / hálózati hiba — a hívó a régi tokennel megy, a 401-út dönt.
   * `definitive: false` = ÁTMENETI hiba (5xx, hálózat, 408, 429, időtúllépés): [Web 7 / T1 javító kör 1, 2026-10-06] F2 — nem
   * fogyasztja el a kérés 401-utáni kísérletét, és betöltéskor sem léptet ki.
   */
  | { kind: 'failed'; definitive: boolean }
  /** közben kijelentkezés / belépés / zár történt — a válaszát NEM írtuk be */
  | { kind: 'discarded' };

/** A kérés megszakad, mert a megújítás alatt megváltozott a bejelentkezés (kilépés, másik felhasználó). */
export class AuthSessionChangedError extends Error {
  constructor() {
    super('Közben megváltozott a bejelentkezés, a kérés nem ment el.');
    this.name = 'AuthSessionChangedError';
  }
}

let generation = 0;
const inFlight = new Map<string, Promise<RefreshOutcome>>();
/** Az a token, amelyre a szerver VÉGLEGESEN elutasította a megújítást (4xx) — azzal nem próbálkozunk újra. */
let definitiveFailureFor: string | null = null;
/** Az utolsó sikeres csere: a még a régi tokennel elindult kérés 401-ére az újat adjuk (ugyanaz a felhasználó). */
let lastRefresh: { from: string; to: string; at: number } | null = null;
/** [Web 7 / T1 javító kör 1, 2026-10-06] F2-M1: az utolsó ÁTMENETI bukás (melyik tokenből, mikor) — a hűtési időhöz. */
let transientFailure: { token: string; at: number } | null = null;

/**
 * A hitelesítési generáció léptetése. Hívandó: kijelentkezés (`authService.logout`), sikeres belépés és
 * újra-belépés, a munkamenet vége (`AuthContext`). A futó megújítás válasza ezután nem írhat a tárolóba.
 */
export function bumpAuthGeneration(): void {
  generation += 1;
  inFlight.clear();
  definitiveFailureFor = null;
  lastRefresh = null;
  transientFailure = null;
}

/** Tesztekhez: a modul-állapot alaphelyzetbe. */
export function __resetTokenRefreshForTests(): void {
  generation = 0;
  inFlight.clear();
  definitiveFailureFor = null;
  lastRefresh = null;
  transientFailure = null;
  refreshedListeners.clear();
}

export type TokenRefreshedListener = (user: User) => void;
const refreshedListeners = new Set<TokenRefreshedListener>();

/**
 * Feliratkozás a sikeres csendes megújításra. Az `AuthContext` ebből tudja meg, ha a szerver más
 * jogosultsággal adta vissza a felhasználót (ugyanaz a szabály, mint a `storage`-útnál és az
 * újra-belépésnél: `hasPermissionChange` → kijelentkeztetés).
 */
export function onTokenRefreshed(cb: TokenRefreshedListener): () => void {
  refreshedListeners.add(cb);
  return () => {
    refreshedListeners.delete(cb);
  };
}

function readStoredToken(): string | null {
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
}

function readStoredUser(): Record<string, unknown> | null {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u && typeof u === 'object' ? u : null;
  } catch {
    return null;
  }
}

/**
 * [Web 7 / T1 javító kör 1, 2026-10-06] M3 — a tárolt felhasználó ÖSSZEFÉSÜLÉSE a megújítás válaszával. A `/auth/refresh`
 * `UserDto`-ja SZŰKEBB, mint a belépésé (`backend/PinyoApi/Controllers/AuthController.cs` `RefreshToken`:
 * nincs `venueId`, `venueName`, `billing…`, `hourlyRate`…, élőben `null`). KORÁBBAN a válasz nyersen felülírta a
 * tárolt `user`-t, így egy megújítás után a következő újratöltés csonka felhasználót olvasott (pl. üres
 * számlázási adat). Ma: UGYANAZON `userId` esetén a válaszban `null`/hiányzó mező NEM írja felül a
 * meglévőt; a válaszban ténylegesen jelen lévő érték (név, szerepkör, aktív/jóváhagyott…) az új.
 * Más `userId`-nál (vagy üres tárolónál) a válasz változatlanul kerül be. Tudatos ár: egy mező, amit a
 * szerver valóban `null`-ra állított (pl. törölt bankszámla), a következő belépésig a régi értéken marad
 * a helyi tárolóban — a szerver ettől még a valós adatot adja minden lekérdezésre.
 */
export function mergeRefreshedUser(previous: Record<string, unknown> | null, fresh: User): User {
  if (!previous || previous.userId !== fresh.userId) return fresh;
  const merged: Record<string, unknown> = { ...previous };
  Object.entries(fresh).forEach(([key, value]) => {
    if (value !== null && value !== undefined) merged[key] = value;
  });
  return merged as unknown as User;
}

function readStoredUserId(): string | null {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u && typeof u.userId === 'string' ? u.userId : null;
  } catch {
    return null;
  }
}

/** A JWT `exp` mezője ezredmásodpercben, vagy `null`, ha a token nem JWT alakú. */
export function tokenExpiryMs(token: string | null | undefined): number | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4)));
    return typeof payload?.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/**
 * Kell-e a kérés ELŐTT megújítani. Nem JWT alakú tokent (nincs `exp`) nem újítunk: a szerver úgyis
 * elutasítaná (aláírás-ellenőrzés), és a régi tesztek álnevű tokenjei (`TOKEN-A`) így a régi úton mennek.
 */
export function needsRefresh(token: string, now = Date.now()): boolean {
  const exp = tokenExpiryMs(token);
  if (exp === null) return false;
  if (exp - now >= REFRESH_AHEAD_MS) return false;
  if (lastRefresh && lastRefresh.to === token && now - lastRefresh.at < FRESH_TOKEN_GRACE_MS) return false;
  return true;
}

/**
 * A szerver-hívás. Külön objektumon, hogy a tesztek egy ponton cserélhessék (`jest.spyOn`).
 * A GLOBÁLIS `axios`-szal megy: annak interceptorai az auth-folyamat URL-jét (`/auth/refresh`)
 * kihagyják, tehát ez a kérés sem megújítást, sem lejárat-jelzést nem indít.
 */
export const refreshTransport = {
  async request(token: string): Promise<{ token: string; user: User; expiration?: string }> {
    // [Web 7 / T1 javító kör 1, 2026-10-06] F2-M2: időkorlát. Az axios `timeout` a böngészőben a kérést is megszakítja; a
    // saját időzítő a garancia (minden adapterre, a tesztekben is), hogy a várakozó kérések ne ragadjanak.
    let timer: ReturnType<typeof setTimeout> | undefined;
    const timeout = new Promise<never>((_, reject) => {
      timer = setTimeout(() => {
        reject(Object.assign(new Error('A bejelentkezés megújítása időtúllépés miatt megszakadt.'), { code: 'ECONNABORTED' }));
      }, REFRESH_TIMEOUT_MS);
    });
    try {
      const res = await Promise.race([
        axios.post(`${API_BASE_URL}/api/auth/refresh`, undefined, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: REFRESH_TIMEOUT_MS,
        }),
        timeout,
      ]);
      return res.data;
    } finally {
      if (timer !== undefined) clearTimeout(timer);
    }
  },
};

function isDefinitiveFailure(err: any): boolean {
  const status = err?.response?.status;
  // 4xx = a szerver elutasította (lejárt a türelmi idő, hamis token, inaktív / jóvá nem hagyott fiók).
  // A 408/429 átmeneti; az 5xx és a hálózati hiba is az — azokra a következő kérés újra próbálkozhat.
  return typeof status === 'number' && status >= 400 && status < 500 && status !== 408 && status !== 429;
}

/** [Web 7 / T1 javító kör 3] M1: a megújítás 2xx-es törzse használható-e (nem üres token + felhasználó-objektum). */
function isValidRefreshBody(data: unknown): data is { token: string; user: User; expiration?: string } {
  if (!data || typeof data !== 'object') return false;
  const d = data as { token?: unknown; user?: unknown };
  return typeof d.token === 'string' && d.token.length > 0 && !!d.user && typeof d.user === 'object';
}

async function runRefresh(from: string): Promise<RefreshOutcome> {
  const startGeneration = generation;
  const startUserId = readStoredUserId();
  // Ha a megújítás alatt bármi megváltozott, a válasz NEM írható be (lásd a fejléc KIJELENTKEZÉS-VERSENY pontját).
  const sessionChanged = () =>
    generation !== startGeneration || isSessionExpiredLocked() || readStoredToken() !== from;

  // [Web 7 / T1 javító kör 1, 2026-10-06] F2-M1: átmeneti bukás → a hűtési idő innen számít.
  const transient = (): RefreshOutcome => {
    transientFailure = { token: from, at: Date.now() };
    return { kind: 'failed', definitive: false };
  };

  let data: { token: string; user: User; expiration?: string };
  try {
    data = await refreshTransport.request(from);
  } catch (err) {
    if (sessionChanged()) return { kind: 'discarded' };
    const definitive = isDefinitiveFailure(err);
    if (definitive) {
      definitiveFailureFor = from;
      return { kind: 'failed', definitive: true };
    }
    return transient();
  }

  if (sessionChanged()) return { kind: 'discarded' };
  // [Web 7 / T1 javító kör 3, 2026-10-06] M1 — 2xx HIBÁS / HIÁNYOS törzzsel (pl. `{}`, vagy egy proxy /
  // statikus tárhely HTML-oldala, nincs `token`) = VÉGLEGES bukás (koordinátor-döntés). KORÁBBAN ÁTMENETInek
  // számított (`transient()`): a lejárt token a tárolóban maradt, minden kérés 401-et kapott, a 401-ág
  // `unavailable`-t adott — a felhasználó a végtelenségig „bent" ragadt 401-ekkel, belépő oldalt SOSEM
  // kapott (forgatókönyv-validátor, mérve). Ma a lejárat-jelzés jön (újra-belépés), és erre a tokenre
  // nincs újabb próba. Tesztek: `tokenRefresh.test.ts` „M1 (kör 3)".
  if (!isValidRefreshBody(data)) {
    definitiveFailureFor = from;
    return { kind: 'failed', definitive: true };
  }
  // Biztonsági tartalék: a szerver a token `nameid`-jából dolgozik, tehát ez nem fordulhat elő; ha mégis,
  // egy másik felhasználó tokenje nem kerülhet a mostani munkamenet helyére.
  if (startUserId && data.user.userId !== startUserId) return { kind: 'failed', definitive: true };

  // [Web 7 / T1 javító kör 1, 2026-10-06] M3: a szűkebb refresh-válasz nem csonkíthatja a tárolt felhasználót.
  const user = mergeRefreshedUser(readStoredUser(), data.user);
  try {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(user));
  } catch {
    return transient();
  }
  lastRefresh = { from, to: data.token, at: Date.now() };
  transientFailure = null;

  Array.from(refreshedListeners).forEach((cb) => {
    try {
      cb(user);
    } catch (err) {
      console.error('Token-refreshed listener failed:', err);
    }
  });
  // Egy feliratkozó (jogosultság-változás) a munkamenetet le is zárhatta — akkor az új token sem használható.
  if (readStoredToken() !== data.token) return { kind: 'discarded' };
  const expiration = typeof data.expiration === 'string' ? data.expiration : undefined;
  return { kind: 'ok', token: data.token, user, expiration };
}

/**
 * Megújítás a megadott tokenből, kiinduló tokenenként EGY futással (a párhuzamos hívók ugyanazt a
 * Promise-t kapják). Zár alatt nem indul.
 */
export function refreshFrom(from: string): Promise<RefreshOutcome> {
  if (isSessionExpiredLocked()) return Promise.resolve({ kind: 'discarded' });
  const running = inFlight.get(from);
  if (running) return running;
  const p = runRefresh(from).finally(() => {
    if (inFlight.get(from) === p) inFlight.delete(from);
  });
  inFlight.set(from, p);
  return p;
}

/**
 * Eldobott megújítás után: a tárolóban lévő tokennel folytatható-e a kérés. Csak ha van token, nem áll a
 * zár, és UGYANANNAK a felhasználónak a tokenje (pl. egy másik fül újított meg közben).
 */
function sameUserStoredToken(originalUserId: string | null): string | null {
  const stored = readStoredToken();
  if (!stored || isSessionExpiredLocked()) return null;
  if (!originalUserId || readStoredUserId() !== originalUserId) return null;
  return stored;
}

/**
 * KÉRÉS INDULÁSAKOR: melyik tokennel menjen a kérés.
 *
 * @param sent a kérésen lévő (vagy az arra szánt) token
 * @returns `token` a küldendő token; `attempt` az indításkori kísérlet sorsa (`RefreshAttempt`) — ha volt
 *          kísérlet, a 401-út nem próbálkozik újra (kérésenként legfeljebb egy, F-B), és ha az átmeneti
 *          hibával bukott, a 401 nem lejárat (F-A). A hívó ezt KÖTELEZŐEN továbbadja az `afterUnauthorized`-nak.
 * @throws AuthSessionChangedError ha a megújítás alatt kijelentkezés / felhasználóváltás történt.
 */
export async function resolveRequestToken(
  sent: string,
  url?: string | null
): Promise<{ token: string; attempt: RefreshAttempt }> {
  if (isAuthFlowUrl(url)) return { token: sent, attempt: 'none' };
  const stored = readStoredToken();
  if (sent !== stored) {
    // A hívó a fejlécet a megújítás ELŐTT számolta ki (pl. `getAuthHeader()`), és közben a csere lefutott.
    const replacement = replacementFor(sent);
    return { token: replacement ?? sent, attempt: 'none' };
  }
  if (isSessionExpiredLocked() || definitiveFailureFor === sent || !needsRefresh(sent)) {
    return { token: sent, attempt: 'none' };
  }
  if (inTransientCooldown(sent)) return { token: sent, attempt: 'none' };
  const originalUserId = readStoredUserId();
  const outcome = await refreshFrom(sent);
  if (outcome.kind === 'ok') return { token: outcome.token, attempt: 'done' };
  if (outcome.kind === 'failed') {
    // A régi tokennel megy: ha még él, a kérés sikeres; ha már lejárt, a 401-ág dönt.
    // [Web 7 / T1 javító kör 2, 2026-10-06] F-A / F-B: KORÁBBAN (1. javító kör F2) az ÁTMENETI bukás nem fogyasztotta
    // el a kérés kísérletét, így egy kérés KÉT megújítást is indíthatott (indításkor + 401 után), és a
    // második átmeneti bukás után a 401 LEJÁRATKÉNT jelződött (kiléptetés, tároló ürítése). Ma a kísérlet
    // elfogyott (`transient`), és a 401-ág ebből tudja, hogy NEM lejárat, hanem átmeneti elérhetetlenség.
    return { token: sent, attempt: outcome.definitive ? 'done' : 'transient' };
  }
  const fallback = sameUserStoredToken(originalUserId);
  // [Web 7 / T1 javító kör 3, 2026-10-06] val3-M1: a megújítás eldobva, a kérés egy MÁSIK fül friss
  // tokenjével megy — a kísérlet ELFOGYOTT (`done`): ha a szerver erre is 401-et ad, a 401-ág NEM indít
  // második megújítást (F-B: kérésenként legfeljebb egy). Őr: `tokenRefresh.test.ts` „val3-M1".
  if (fallback) return { token: fallback, attempt: 'done' };
  throw new AuthSessionChangedError();
}

/**
 * [Web 7 / T1 javító kör 1, 2026-10-06] F2-M1: a hűtési idő alatt (átmeneti bukás után 30 s) a MÉG ÉRVÉNYES tokennel nem
 * indítunk újabb ELŐRE-megújítást. Lejárt tokennél nincs hűtés (ott a megújítás az egyetlen út).
 */
function inTransientCooldown(sent: string, now = Date.now()): boolean {
  if (!transientFailure || transientFailure.token !== sent) return false;
  if (now - transientFailure.at >= TRANSIENT_COOLDOWN_MS) return false;
  const exp = tokenExpiryMs(sent);
  return exp !== null && exp > now;
}

/** A már lecserélt token helyett az új — csak ha MI cseréltük, és a tárolóban még az új van. */
function replacementFor(sent: string): string | null {
  if (!lastRefresh || lastRefresh.from !== sent) return null;
  if (isSessionExpiredLocked()) return null;
  return readStoredToken() === lastRefresh.to ? lastRefresh.to : null;
}

const REPORT: UnauthorizedOutcome = { kind: 'report' };
const UNAVAILABLE: UnauthorizedOutcome = { kind: 'unavailable' };
const retryWith = (token: string | null): UnauthorizedOutcome => (token ? { kind: 'retry', token } : REPORT);

/**
 * 401 UTÁN: mi a teendő (lásd `UnauthorizedOutcome`). CSAK 401-re hívandó (F-C: a 403 / 5xx nem
 * hitelesítési hiba — azokra se megújítás, se ismétlés; a hívók a státuszt ELŐTTE vizsgálják).
 *
 * [Web 7 / T1 javító kör 2, 2026-10-06] KORÁBBAN `tokenAfterUnauthorized` (`string | null`): az átmeneti
 * bukás és a végleges elutasítás ugyanazt a `null`-t adta → mindkettő lejárat-jelzés lett (F-A).
 *
 * @param startAttempt a kérés INDULÁSAKORI kísérlet sorsa (`resolveRequestToken`): F-B — ha volt kísérlet,
 *        itt nincs újabb (kérésenként legfeljebb EGY megújítás); F-A — ha az átmeneti hibával bukott, a 401
 *        `unavailable`, nem lejárat.
 */
export async function afterUnauthorized(
  sent: string | null,
  url: string | null | undefined,
  startAttempt: RefreshAttempt
): Promise<UnauthorizedOutcome> {
  // [Web 7 / T1 javító kör 1, 2026-10-06] F1-M7 — a zár-őr ITT (`isSessionExpiredLocked()`) viselkedésben REDUNDÁNS, és
  // szándékosan marad (olcsó, korai kilépés, és nem függ a lenti hívások belső sorrendjétől). Miért nem
  // különböztethető meg teszttel: zár alatt (1) a `replacementFor` maga is `null`-t ad (saját zár-őre),
  // (2) a `refreshFrom` a zárra `discarded`-et ad hálózati hívás NÉLKÜL, (3) a `sameUserStoredToken` a
  // zárra `null`-t ad — tehát az eredmény (null, nincs `/auth/refresh`) e sor nélkül is ugyanaz. A
  // `refreshFrom` zár-őre viszont ÖNÁLLÓ védvonal (a kézi `authService.refreshToken` és a betöltéskori
  // `refreshStoredSession` közvetlenül hívja) — azt a `tokenRefresh.test.ts` „F1-M7" tesztje őrzi.
  if (!sent || isAuthFlowUrl(url) || isSessionExpiredLocked()) return REPORT;
  const stored = readStoredToken();
  // Egy MÁSIK kérés közben lecserélte a tokent: ismétlés az újjal (ez nem újabb megújítás).
  if (sent !== stored) return retryWith(replacementFor(sent));
  // [Web 7 / T1 javító kör 2, 2026-10-06] F-B: a kérés EGY megújítása elfogyott → nincs második.
  if (startAttempt === 'done') return REPORT;
  // [Web 7 / T1 javító kör 2, 2026-10-06] F-A: az indításkori megújítás átmeneti hibával bukott → NEM lejárat.
  if (startAttempt === 'transient') return UNAVAILABLE;
  if (definitiveFailureFor === sent) return REPORT;
  // Nem JWT alakú token: a szerver úgyis elutasítaná — nincs kísérlet (lásd `needsRefresh`).
  if (tokenExpiryMs(sent) === null) return REPORT;
  const originalUserId = readStoredUserId();
  const outcome = await refreshFrom(sent);
  if (outcome.kind === 'ok') return retryWith(outcome.token);
  if (outcome.kind === 'failed') {
    if (outcome.definitive) return REPORT;
    // [Web 7 / T1 javító kör 2, 2026-10-06] F-A: átmeneti bukás → a tároló marad, nincs lejárat-jelzés —
    // de csak ha közben nem változott a bejelentkezés (akkor a meglévő út dönt, a tároló-összevetéssel).
    // [Web 7 / T1 javító kör 3, 2026-10-06] val3-M2 — SZÁNDÉKOS MÁSODIK VÉDVONAL: ma ez a tároló- és
    // zár-ellenőrzés viselkedésben redundáns, mert a `runRefresh` `sessionChanged()`-je (generáció, zár,
    // tároló-egyezés) ugyanezt a bukás pillanatában már megnézte, és változásnál `discarded`-et adott
    // volna — így ide `failed` csak változatlan tárolóval jut (a két pont között nincs `await`). Marad,
    // hogy egy jövőbeli átrendezés (pl. egy `await` a kettő közé) se adhasson `unavailable`-t egy közben
    // kijelentkezett / lecserélt munkamenetre.
    return readStoredToken() === sent && !isSessionExpiredLocked() ? UNAVAILABLE : REPORT;
  }
  return retryWith(sameUserStoredToken(originalUserId));
}

/** A betöltéskori megújítás eredménye — [Web 7 / T1 javító kör 1, 2026-10-06] F2. */
export type StoredSessionRefresh =
  /** megújult: a tároló már az új tokent és (összefésült) felhasználót tartja */
  | { kind: 'ok'; user: User }
  /** ÁTMENETI hiba: a tároló ÉRINTETLEN, a felhasználó bent maradhat; a következő kérés újra próbál */
  | { kind: 'transient' }
  /** végleges elutasítás / nincs token / közben megváltozott a bejelentkezés → a régi (kiléptető) út */
  | { kind: 'none' };

/**
 * Oldal-betöltéskor (`AuthContext` init): a tárolt, LEJÁRT token megújítása. Siker esetén a tároló már az
 * új tokent és felhasználót tartja.
 *
 * [Web 7 / T1 javító kör 1, 2026-10-06] F2: KORÁBBAN `User | null` volt, és az átmeneti hiba (a szerver épp újraindul, 5xx,
 * 429, nincs hálózat) is `null`-t adott → az `AuthContext` törölte a tárolót és kiléptetett, pedig a
 * token a szerver 30 napos türelmi ideje miatt még megújítható lett volna. Ma az átmeneti hiba külön
 * eredmény (`transient`): a hívó NEM töröl, és a lejárt token miatt a következő kérés indulásakor
 * (`resolveRequestToken`, lejárt tokennél nincs hűtés) újra megpróbálja a megújítást.
 */
export async function refreshStoredSession(): Promise<StoredSessionRefresh> {
  const stored = readStoredToken();
  if (!stored || tokenExpiryMs(stored) === null) return { kind: 'none' };
  const originalUserId = readStoredUserId();
  const outcome = await refreshFrom(stored);
  if (outcome.kind === 'ok') return { kind: 'ok', user: outcome.user };
  if (outcome.kind === 'failed' && !outcome.definitive && readStoredToken() === stored) return { kind: 'transient' };
  // [Web 7 / T1 javító kör 3, 2026-10-06] B1 — TÖBB FÜL EGYSZERRE töltődik ugyanazzal a lejárt tokennel.
  // Mindegyik fül (külön modul-állapot, külön `inFlight`) elküldi a saját `/auth/refresh`-ét; az ELSŐ
  // beérő beírja az új tokent, a többi fül válaszánál a tárolóban már az az új token van →
  // `sessionChanged()` → `discarded`. KORÁBBAN ez `none` lett → az `AuthContext` init feltétel nélkül
  // ürítette a tárolót → törölte az 1. fül ÉRVÉNYES tokenjét → a többi fül `storage` eseményt kapott és
  // kilépett: mérve (forgatókönyv-validátor, `scratchpad/t1-scen/fe/e2e/s_tabs.spec.ts` X1/X1b) 3 fül
  // egyszerre / 400 ms eltolással → mindhárom `/belepes` „Lejárt…", a tároló üres, holott mindhárom
  // refresh 200 volt. Ma: ha a tárolóban UGYANANNAK a felhasználónak egy MÁSIK (JWT alakú) tokenje van,
  // azt vesszük át (`ok` a tárolt felhasználóval) — a tárolót NEM írjuk. Más felhasználó / üres tároló /
  // zár → `none` (a hívó dönt; az init ma csak VÁLTOZATLAN tárolót ürít).
  // Tesztek: `tokenRefresh.test.ts` „B1", `AuthContext.sessionExpired.test.tsx` „B1",
  // E2E `flow-token-refresh.spec.ts` „B1".
  const adopted = adoptStoredSession(stored, originalUserId);
  if (adopted) return { kind: 'ok', user: adopted };
  return { kind: 'none' };
}

/**
 * [Web 7 / T1 javító kör 3, 2026-10-06] B1: egy MÁSIK fül által közben beírt munkamenet átvétele — csak
 * ha a tárolt token MÁS, mint amiből mi indultunk, JWT alakú, nem áll a zár, és UGYANAZ a felhasználó
 * (`sameUserStoredToken`).
 * DÖNTÉS: a token lejáratát a GÉP ÓRÁJA szerint SZÁNDÉKOSAN NEM vizsgáljuk. Indok: ezt a tokent a betöltésünk
 * ALATT írta egy másik fül, tehát a szerver épp most adta ki (a tárolóba token csak belépésből vagy
 * megújításból kerül); a gép órája viszont nem mérvadó — mérve (`s_tabs.spec.ts` X1, 25 órával előre
 * állított böngésző-óra) a szerver friss tokenje a kliens szerint „lejárt", és egy lejárat-feltétel
 * mellett a 2. és 3. fül ugyanúgy kilépett, míg az 1. fül a SAJÁT (ugyanilyen) tokenjével bent maradt.
 * Ha a token mégis halott lenne, a következő kérés megújítja (`resolveRequestToken`), vagy a 401-út jelez.
 */
function adoptStoredSession(from: string, originalUserId: string | null): User | null {
  const token = sameUserStoredToken(originalUserId);
  if (!token || token === from) return null;
  if (tokenExpiryMs(token) === null) return null;
  const user = readStoredUser();
  return user ? (user as unknown as User) : null;
}
